import { useEffect, useCallback } from 'react';
import { colors } from '../../../options/colors';
import Chart from 'chart.js/auto';
import SectionSpinner from '../../Loading/SectionSpinner/SectionSpinner';
import NoResultsText from '../../Typography/NoResultsText/NoResultsText';
import { Box } from '@mui/material';

const ChartImage = ({ ident, width, data }) =>
{

  const createChart = useCallback((chartLabels, chartData) =>
  {

  }, []);

  return (
    <>
      <Box sx={{
        width,
        //  backgroundColor: 'yellow',
        margin: 'auto'
      }} >
        <img id={ident + 'ChartImage'} width="100%" alt=""/>
      </Box >
    </>
  );
};

export default ChartImage;
